var React = require('react');

function SaveAlt (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M14.2,8v6.2H1.8V8H0v6.2c0,1,0.8,1.8,1.8,1.8h12.4c1,0,1.8-0.8,1.8-1.8V8H14.2z M8.9,8.6l2.3-2.3l1.3,1.3L8,12L3.6,7.6\n\tl1.3-1.3l2.3,2.3V0h1.8V8.6z","fill":"currentColor"}));
}

SaveAlt.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","style":{"enableBackground":"new 0 0 16 16"},"xmlSpace":"preserve"};

module.exports = SaveAlt;

SaveAlt.default = SaveAlt;
